import type { VoidFunctionComponent } from 'react';

import { useCurrentProject } from '../../../../hooks/api/projects/useCurrentProject';
import Loader from '../../../generic/Loader';
import Panel from '../../../generic/Panel';
import { projectTypes } from '../../shared/projectTypesIconMap';

import styles from './ProjectSummaryV2.module.less';

export const ProjectSummaryV2: VoidFunctionComponent = () => {
  const { data: project, isLoading } = useCurrentProject();

  if (!project || isLoading) {
    return (
      <div className="padding-top-sm container">
        <Loader />
      </div>
    );
  }

  const projectTypeTitle = (project.type && projectTypes[project.type]) ? projectTypes[project.type].title : 'Other';

  return (
    <div className="padding-top-xl container">
      <Panel>
        <div className={styles.summaryText}>Summary</div>
        <div className={styles.projectTypeTitle}>{projectTypeTitle}</div>
        <div className="padding-top-lg">Project Summary V2 Coming Soon</div>
      </Panel>
    </div>
  );
};
